import { render } from "./MGButton.vue?vue&type=template&id=7693e9f8&scoped=true"
import script from "./MGButton.vue?vue&type=script&lang=js"
export * from "./MGButton.vue?vue&type=script&lang=js"

import "./MGButton.vue?vue&type=style&index=0&id=7693e9f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7693e9f8"]])

export default __exports__